import { render, staticRenderFns } from "./Employers.vue?vue&type=template&id=07498eff&scoped=true&"
import script from "./Employers.vue?vue&type=script&lang=js&"
export * from "./Employers.vue?vue&type=script&lang=js&"
import style0 from "./Employers.vue?vue&type=style&index=0&id=07498eff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07498eff",
  null
  
)

export default component.exports